import styled from 'styled-components';
import PropTypes from 'prop-types';
import CircularProgress from '@material-ui/core/CircularProgress';
import { BorderColors } from '@styles/index';

const StyledCircularProgress = styled(CircularProgress)`
  color: ${({ $customColor }) => $customColor};
`;

const CircularLoader = ({ color, size, className }) => {
  return (
    <StyledCircularProgress
      $customColor={color}
      size={size}
      className={className}
    />
  );
};

export default CircularLoader;

CircularLoader.propTypes = {
  color: PropTypes.string,
  size: PropTypes.number,
  className: PropTypes.string
};

CircularLoader.defaultProps = {
  color: BorderColors.GREEN,
  size: 40,
  className: ''
};
